import React from 'react';
import { COLORS } from '../utils/constants.js';

export default function Header({ profile }) {
  return (
    <header
      style={{
        padding: '16px 24px',
        borderBottom: `1px solid ${COLORS.border}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        background: `linear-gradient(135deg, ${COLORS.surface} 0%, ${COLORS.bg} 100%)`,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
        <div
          style={{
            width: 36,
            height: 36,
            borderRadius: 8,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: `linear-gradient(135deg, ${COLORS.accent}, ${COLORS.accentDim})`,
            fontFamily: "'Space Mono', monospace",
            fontWeight: 700,
            fontSize: 16,
            color: COLORS.bg,
          }}
        >
          S
        </div>
        <div>
          <h1 style={{ margin: 0, fontSize: 18, fontWeight: 700, letterSpacing: -0.5 }}>
            SALES<span style={{ color: COLORS.accent }}>PORTAL</span>
          </h1>
          <p
            style={{
              margin: 0,
              fontSize: 11,
              color: COLORS.textDim,
              fontFamily: "'Space Mono', monospace",
            }}
          >
            Apollo · Claude AI · GetResponse
          </p>
        </div>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
        {profile && (
          <div style={{ textAlign: 'right' }}>
            <p style={{ margin: 0, fontSize: 13, fontWeight: 600 }}>{profile.name}</p>
            <p style={{ margin: 0, fontSize: 11, color: COLORS.textDim }}>
              {profile.credits} credits · {profile.ai_credits} AI credits
            </p>
          </div>
        )}
        <div
          style={{
            width: 34,
            height: 34,
            borderRadius: '50%',
            background: `linear-gradient(135deg, ${COLORS.blue}, ${COLORS.purple})`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 14,
            fontWeight: 700,
            color: '#fff',
          }}
        >
          LM
        </div>
      </div>
    </header>
  );
}
